import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route } from 'react-router-dom';
import { Layout } from './Layout';
import { Home } from './Home';
import { Login } from './Login';
import { VPCAuthorizationCallback } from './VPCAuthorizationCallback';

const queryClient = new QueryClient();

/** The root component of the app */
export const App = () => (
  <QueryClientProvider client={queryClient}>
    <Layout>
      <Route exact path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/vpc-authorization-callback" component={VPCAuthorizationCallback} />
    </Layout>
  </QueryClientProvider>
);
